import { useReveal } from "../hooks/useReveal";
import { ParallaxBg } from "../components/ParallaxBg";
import { VideoEmbed } from "../components/VideoEmbed";
import { WEBINAR } from "../lib/copy";

const CREDS = [
  { k: "COMPANY", v: "Property Lending Team" },
  { k: "NMLS#", v: "2050201" },
  { k: "CO. NMLS#", v: "1660690" },
  { k: "LICENSED IN", v: "NC, SC, GA, FL, TX, TN, CO, IN" },
];

export default function Host() {
  const ref = useReveal();
  return (
    <section id="host" ref={ref} className="py-28 md:py-36" style={{ background: "rgba(255,255,255,0.015)" }} data-testid="host-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="section-label mb-14 reveal-up">[002] — YOUR HOST</p>
        <div className="grid lg:grid-cols-[420px_1fr] gap-14 items-start">
          <div className="host-panel reveal-up" data-testid="host-portrait-panel">
            <img src="/matthew.jpg" alt="Matthew Lake-Nestor" className="host-photo" data-testid="host-headshot" />
            <span className="corner tl" /><span className="corner tr" /><span className="corner bl" /><span className="corner br" />
            <div className="host-nameplate" data-testid="host-nameplate">
              <p className="font-extrabold text-sm uppercase tracking-wide">Matthew Lake-Nestor</p>
              <p className="mono" style={{ fontSize: 9, letterSpacing: "0.18em", color: "rgba(240,236,228,0.55)" }}>MORTGAGE ADVISOR | TEAM LEAD · PROPERTY LENDING TEAM</p>
            </div>
          </div>
          <div>
            <p className="eyebrow mb-4" style={{ color: "#FFFFFF", fontSize: 12 }}>MEET MATTHEW LAKE-NESTOR</p>
            <h2 className="reveal-up font-black uppercase mb-8" style={{ fontSize: "clamp(28px, 3.2vw, 44px)", letterSpacing: "-0.02em", lineHeight: 1.05 }}>
              MORTGAGE GUIDANCE FROM SOMEONE WHO UNDERSTANDS THE <span style={{ color: "#3D7BFF" }}>WHOLE</span> PROCESS.
            </h2>
            <div className="reveal-up mb-8" style={{ width: 64, height: 2, background: "#3D7BFF" }} />
            <div className="space-y-5 reveal-up mb-10" style={{ color: "rgba(240,236,228,0.62)", lineHeight: 1.8, fontSize: 15 }} data-testid="host-bio">
              <p>
                I'm Matthew Lake-Nestor, a licensed Mortgage Loan Advisor and Realtor. I've developed a particular passion for helping Veterans and military families understand and make the most of the home loan benefit they've earned. Having helped hundreds of families understand their financing options and navigate the mortgage process with confidence, I'm excited about the opportunity to help you do the same. My real-estate experience gives me a unique perspective that many mortgage professionals don't have: I understand how financing decisions can affect the offer, the contract, the appraisal, the closing timeline, and ultimately a buyer's ability to get the keys.
              </p>
              <p>
                A successful home purchase takes coordination. Your Realtor has an important role in helping you find and negotiate the right home, while your Mortgage Loan Advisor is responsible for helping you understand and secure the financing. My job is to communicate clearly, anticipate financing issues, and work alongside your real-estate professional so everyone is working toward the same goal—a smooth, successful closing.
              </p>
              <p>
                That's the approach behind Property Lending Team: educate first, communicate clearly, and make sure you understand the numbers before you make major decisions. In this webinar, I'll show you what VA buyers should understand before—and during—the homebuying process, so you're better prepared when it's time to make your move.
              </p>
              <p>
                And if you don't already have a Realtor, I can help connect you with the right real-estate professional—someone who understands the VA homebuying process and shares our commitment to communication, coordination, and taking great care of you throughout the transaction.
              </p>
            </div>
          </div>
        </div>
        <div className="reveal-up mt-14 mb-10 mx-auto" style={{ maxWidth: 720 }}>
          <div className="hero-video-frame" data-testid="host-video">
            <VideoEmbed
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_va-loan-guide/artifacts/vl4cc3s7_MOF%201.mp4"
              poster="/poster-mof.jpg"
              testid="host-video-player"
            />
          </div>
        </div>
        <div className="cred-grid reveal-up mb-10 mx-auto" style={{ maxWidth: 720 }} data-testid="host-credentials-grid">
          {CREDS.map((c) => (
            <div className="cred-cell" key={c.k}>
              <p className="k">{c.k}</p>
              <p className="v">{c.v}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
